import axios from "axios";

export function createAPI(baseURL) {
  const api = axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
    },
  });

  return api;
}
